import { GameClient } from '../../gameClient/gameClient';
import { SetConsentResultCommand } from '../../gameClient/clientCommands/setConsentResultCommand';
import { CurrentUser } from '../../general/modules/user/currentUser';
import { ConsentSources } from '../../constants/ConsentSources';

type SetConsentStateParams = {
    suid: string,
    email: string,
    consent: boolean
}

export class SetConsentStateHandler {
    public handle(params: SetConsentStateParams): void {
        CurrentUser.getInstance().setConsentState(params.email, params.consent, ConsentSources.POPUP)
            .then((saveSuccess: boolean)=>{
                GameClient.getInstance().sendCommand(new SetConsentResultCommand({
                    consent: saveSuccess
                }));
            });
    }
}
